import { render } from "./Survey.vue?vue&type=template&id=81586042&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=81586042&scoped=true&lang=css"

import exportComponent from "E:\\back-to-class-master\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81586042"]])

export default __exports__